/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.24.0
 */

import { ReactElement } from 'react';

import { LinkBlock } from '@/main/components/common';
import { RoutePath } from '@/main/routes/constants/routesConstants';
import { stringFormatParams } from '@/main/utils/stringFormat';

import { IUserNotificationTranslation } from '../../internationalization/types';
import { GROUP_OVERFLOW_LIMIT } from '../constants';
import { INotificationsEntity } from '../types';
import { getIsOverflowNotification, getOrderNotificationURL } from './notificationsUtils';

export const getOrdersNotificationData = (
    entity: INotificationsEntity,
    isGroup: boolean,
    translation: IUserNotificationTranslation,
    onLinkClick?: () => void,
): [string, ReactElement] => {
    const isOverflow = getIsOverflowNotification(entity);

    const content = getOrdersNotificationContent(entity, translation, { isGroup, isOverflow });

    const linkHref = isGroup ? RoutePath.orders : getOrderNotificationURL(entity.id);

    const ItemLink = (
        <div>
            <LinkBlock withArrow url={linkHref} onClick={onLinkClick}>
                {translation.linkText.default}
            </LinkBlock>
        </div>
    );
    return [content, ItemLink];
};

interface IGetOrdersNotificationContentOptions {
    isGroup: boolean;
    isOverflow: boolean;
}

export const getOrdersNotificationContent = (
    entity: INotificationsEntity,
    translation: IUserNotificationTranslation,
    options: IGetOrdersNotificationContentOptions,
) => {
    const { isGroup, isOverflow } = options;

    if (!isGroup) return `${translation.content.orders.singleTitle} ${entity.def}`;

    return isOverflow
        ? stringFormatParams(translation.content.orders.overflowTitle, {
              count: GROUP_OVERFLOW_LIMIT,
          })
        : stringFormatParams(translation.content.orders.groupTitle, {
              count: entity.count || '',
          });
};
